/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeJarClassNamesDto,
  ApiEnvelopeJarTranslatedLogDto,
  ApiEnvelopeJarVersionListDto,
  JarKeyRequest,
  JarTranslateLogRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type jarDownloadDownloadJarResponse200 = {
  data: Blob
  status: 200
}

export type jarDownloadDownloadJarResponse400 = {
  data: Blob
  status: 400
}

export type jarDownloadDownloadJarResponse404 = {
  data: Blob
  status: 404
}

export type jarDownloadDownloadJarResponseSuccess = (jarDownloadDownloadJarResponse200) & {
  headers: Headers;
};
export type jarDownloadDownloadJarResponseError = (jarDownloadDownloadJarResponse400 | jarDownloadDownloadJarResponse404) & {
  headers: Headers;
};

export type jarDownloadDownloadJarResponse = (jarDownloadDownloadJarResponseSuccess | jarDownloadDownloadJarResponseError)

export const getJarDownloadDownloadJarUrl = (version: string,) => {




  return `/api/JarDownload/${version}`
}

export const useJarDownloadDownloadJarHook = (): (version: string, options?: RequestInit) => Promise<jarDownloadDownloadJarResponse> => {

      const customFetcher = useSfetchMutator();
      return (version: string, options?: RequestInit) => {

        return customFetcher(getJarDownloadDownloadJarUrl(version),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type jarDownloadGetKeyResponse200 = {
  data: void
  status: 200
}

export type jarDownloadGetKeyResponseSuccess = (jarDownloadGetKeyResponse200) & {
  headers: Headers;
};
;

export type jarDownloadGetKeyResponse = (jarDownloadGetKeyResponseSuccess)

export const getJarDownloadGetKeyUrl = () => {




  return `/api/JarDownload/GetKey`
}

export const useJarDownloadGetKeyHook = (): (jarKeyRequest?: JarKeyRequest, options?: RequestInit) => Promise<jarDownloadGetKeyResponse> => {

      const customFetcher = useSfetchMutator();
      return (jarKeyRequest?: JarKeyRequest, options?: RequestInit) => {

        return customFetcher(getJarDownloadGetKeyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(jarKeyRequest)
  }
);
      }
  }


export type jarDownloadGetVersionsResponse200 = {
  data: string[]
  status: 200
}

export type jarDownloadGetVersionsResponseSuccess = (jarDownloadGetVersionsResponse200) & {
  headers: Headers;
};
;

export type jarDownloadGetVersionsResponse = (jarDownloadGetVersionsResponseSuccess)

export const getJarDownloadGetVersionsUrl = () => {




  return `/api/JarDownload/Versions`
}

export const useJarDownloadGetVersionsHook = (): ( options?: RequestInit) => Promise<jarDownloadGetVersionsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getJarDownloadGetVersionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type jarDownloadGetVersionsReleaseResponse200 = {
  data: ApiEnvelopeJarVersionListDto
  status: 200
}

export type jarDownloadGetVersionsReleaseResponse400 = {
  data: ApiEnvelopeJarVersionListDto
  status: 400
}

export type jarDownloadGetVersionsReleaseResponseSuccess = (jarDownloadGetVersionsReleaseResponse200) & {
  headers: Headers;
};
export type jarDownloadGetVersionsReleaseResponseError = (jarDownloadGetVersionsReleaseResponse400) & {
  headers: Headers;
};

export type jarDownloadGetVersionsReleaseResponse = (jarDownloadGetVersionsReleaseResponseSuccess | jarDownloadGetVersionsReleaseResponseError)

export const getJarDownloadGetVersionsReleaseUrl = () => {




  return `/api/JarDownload/Versions/release`
}

export const useJarDownloadGetVersionsReleaseHook = (): ( options?: RequestInit) => Promise<jarDownloadGetVersionsReleaseResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getJarDownloadGetVersionsReleaseUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type jarDownloadGetAllClassNamesResponse200 = {
  data: ApiEnvelopeJarClassNamesDto
  status: 200
}

export type jarDownloadGetAllClassNamesResponseSuccess = (jarDownloadGetAllClassNamesResponse200) & {
  headers: Headers;
};
;

export type jarDownloadGetAllClassNamesResponse = (jarDownloadGetAllClassNamesResponseSuccess)

export const getJarDownloadGetAllClassNamesUrl = () => {




  return `/api/JarDownload/AllClassNames`
}

export const useJarDownloadGetAllClassNamesHook = (): ( options?: RequestInit) => Promise<jarDownloadGetAllClassNamesResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getJarDownloadGetAllClassNamesUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type jarDownloadTranslateLogResponse200 = {
  data: ApiEnvelopeJarTranslatedLogDto
  status: 200
}

export type jarDownloadTranslateLogResponseSuccess = (jarDownloadTranslateLogResponse200) & {
  headers: Headers;
};
;

export type jarDownloadTranslateLogResponse = (jarDownloadTranslateLogResponseSuccess)

export const getJarDownloadTranslateLogUrl = () => {




  return `/api/JarDownload/TranslateLog`
}

export const useJarDownloadTranslateLogHook = (): (jarTranslateLogRequest?: JarTranslateLogRequest, options?: RequestInit) => Promise<jarDownloadTranslateLogResponse> => {

      const customFetcher = useSfetchMutator();
      return (jarTranslateLogRequest?: JarTranslateLogRequest, options?: RequestInit) => {

        return customFetcher(getJarDownloadTranslateLogUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(jarTranslateLogRequest)
  }
);
      }
  }


